export enum UserAccount {
	REGISTER = "REGISTER",
	ACCOUNT_EXISTS = "ACCOUNT_EXISTS",
}
